import React, {Fragment} from 'react';
import {Icon, Flex, Button, Layout} from 'components';
import {config} from 'helpers';

export function MembershipMore({ popup }) {
  return (
    <Fragment>
      <Layout.Header justified>
        <h1>Premium account</h1>
        <Icon className="secondary" name="close" onClick={popup.close} />
      </Layout.Header>
      <p>
        Premium account gives you access to additional features and functionality.
        Premium subscription let you set unlimited goals, schedule unlimited routines, create unlimited activities, add unlimited notes and journal records,
        add custom categories and custom questions, view past performance, export your data, collaborate with a team of friends or colleagues,
        and get full access to the comprehensive '{ config.identityModule }' and '{ config.clarityModule }' modules.
      </p>
      <p>
        Premium subscription is available for { config.plans.map(plan => plan.description).join(', ') } through an auto-renewing subscription.
        Your subscription automatically renews unless you cancel your subscription at least 24-hours before the end of the current period.
      </p>
      <p>
        Subscriptions will be billed to the credit card or PayPal account you provide.
        If payment is not received or cannot be charged to your preferred payment method for any reason,
        {config.appName} reserves the right to either suspend or terminate your access to the program.
      </p>
      <Flex className="spacing">
        <Button href={`https://${config.appHost}/terms/`} target="_blank">Terms of Use</Button>
        <Button href={`https://${config.appHost}/privacy/`} target="_blank">Privacy Policy</Button>
      </Flex>
    </Fragment>
  );
}
